module.exports = __webpack_public_path__ + "img/electronic_certificate.60f5561e.png";